/*
  JAY NICK custom: compulsory ring size selector (snippets/jn-ring-size.liquid).

  Product page
  - Adding to bag is blocked until a size is chosen; the customer is taken to the selector.
  - "Buy it now" stays visible: without a size it leads the customer to the selector;
    with a size it adds the ring to the bag and goes straight to checkout.
  - The chosen size is copied into any other add-to-cart form in the same section (e.g. the sticky bar).
  - Size-band products (e.g. wedding bands priced "H - P" / "P - Z"): choosing an exact size selects
    the matching band variant automatically, so the price updates through the product's own variants.

  Cart
  - Checkout is blocked, with a clear message, if a ring that needs a size somehow has none
    (for example if it reached the bag another way).
*/
(function () {
  var C = window.JNRingSize;
  if (!C) return;
  var PROP = C.propertyName || 'Ring size';

  function needsSize(line) {
    // Mirrors the Liquid rule in jn-ring-size.liquid (tags are not available in the cart).
    if (line.properties && line.properties[PROP]) return false;
    var last = (line.product_type || '').trim().split(' ').pop();
    if (['Rings', 'Ring', 'Band', 'Bands'].indexOf(last) === -1) return false;
    if ((line.handle || '').indexOf('ready-') === 0) return false;
    var opts = line.options_with_values || [];
    for (var i = 0; i < opts.length; i++) {
      // An exact in-stock size (not a price band) means no size is needed.
      if (opts[i].name === 'Ring Size' && String(opts[i].value).indexOf(' - ') === -1) return false;
    }
    return true;
  }

  function sectionOf(el) { return el.closest('.shopify-section') || document; }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function json(url, body) {
    var opts = body
      ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }
      : { headers: { Accept: 'application/json' } };
    return fetch(url, opts).then(function (r) { return r.json(); });
  }

  function syncForms(select) {
    sectionOf(select).querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.contains(select)) return;
      var input = form.querySelector('input[data-jn-ring-size-mirror]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + PROP + ']';
        input.setAttribute('data-jn-ring-size-mirror', '');
        form.appendChild(input);
      }
      input.value = select.value;
      input.disabled = !select.value;
    });
  }

  function showError(select) {
    var box = select.closest('[data-jn-ring-size]');
    box.classList.add('jn-ring-size--invalid');
    box.querySelector('[data-jn-ring-size-error]').hidden = false;
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    select.focus({ preventScroll: true });
  }


  // Size-band products: select the band variant that contains the chosen size.
  function bandFor(bands, size) {
    var i = C.sizes.indexOf(size);
    if (i < 0 || !bands.length) return null;
    var first = null, last = null;
    for (var b = 0; b < bands.length; b++) {
      var parts = String(bands[b]).split(' - ');
      var from = C.sizes.indexOf(parts[0].trim());
      var to = C.sizes.indexOf((parts[1] || '').trim());
      if (from < 0 || to < 0) continue;
      if (i >= from && i <= to) return bands[b];
      if (first === null || from < first.from) first = { from: from, value: bands[b] };
      if (last === null || to > last.to) last = { to: to, value: bands[b] };
    }
    if (first && i < first.from) return first.value;
    return last ? last.value : null;
  }

  function syncBand(box, size) {
    var pos = box.getAttribute('data-band-position');
    if (!pos || !size) return;
    var bands;
    try { bands = JSON.parse(box.getAttribute('data-bands') || '[]'); } catch (err) { return; }
    var band = bandFor(bands, size);
    if (!band) return;
    var scope = sectionOf(box);
    var radios = scope.querySelectorAll('input[type="radio"][name="Ring Size-' + pos + '"]');
    for (var r = 0; r < radios.length; r++) {
      if (radios[r].value === band) {
        if (!radios[r].checked) radios[r].click();
        return;
      }
    }
    var select = scope.querySelector('select[name="options[Ring Size]"]');
    if (select && select.value !== band) {
      select.value = band;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-jn-ring-size] select');
    if (!select) return;
    var box = select.closest('[data-jn-ring-size]');
    box.classList.remove('jn-ring-size--invalid');
    box.querySelector('[data-jn-ring-size-error]').hidden = true;
    syncForms(select);
    syncBand(box, select.value);
  });

  // Runs before the theme's own submit handler (capture phase on document).
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var select = sectionOf(form).querySelector('[data-jn-ring-size] select');
    if (!select || select.value) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    showError(select);
  }, true);

  // "Buy it now": without a size, lead to the selector; with a size, add to bag and go to checkout.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.shopify-payment-button');
    if (!btn) return;
    var section = btn.closest('.shopify-section');
    var select = section && section.querySelector('[data-jn-ring-size] select');
    if (!select) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!select.value) { showError(select); return; }
    var form = select.closest('form');
    var idInput = form && form.querySelector('input[name="id"]');
    if (!idInput || idInput.disabled) return;
    var qtyInput = section.querySelector('input[name="quantity"][form="' + form.id + '"]') || form.querySelector('input[name="quantity"]');
    var props = {};
    new FormData(form).forEach(function (value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && value !== '') props[m[1]] = value;
    });
    btn.setAttribute('aria-busy', 'true');
    json(root() + 'cart/add.js', {
      items: [{ id: parseInt(idInput.value, 10), quantity: parseInt((qtyInput && qtyInput.value) || '1', 10), properties: props }]
    }).then(function () {
      window.location.href = root() + 'checkout';
    }).catch(function (err) {
      btn.removeAttribute('aria-busy');
      console.error('JAY NICK ring size:', err);
    });
  }, true);

  // Checkout safeguard: block if a ring in the bag has no size.
  var proceeding = false;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[name="checkout"]');
    if (!btn || proceeding) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    btn.setAttribute('aria-busy', 'true');
    json(root() + 'cart.js').then(function (cart) {
      btn.removeAttribute('aria-busy');
      var missing = cart.items.filter(needsSize).map(function (l) { return l.product_title; });
      var holder = btn.parentNode;
      var old = holder.querySelector('.jn-ring-size__cart-error');
      if (old) old.remove();
      if (missing.length) {
        var msg = document.createElement('p');
        msg.className = 'jn-ring-size__cart-error';
        msg.setAttribute('role', 'alert');
        msg.textContent = 'Please choose a ring size for: ' + missing.join(', ') +
          '. Remove it from your bag and add it again from its product page, choosing your size.';
        holder.insertBefore(msg, btn);
        return;
      }
      proceeding = true;
      window.location.href = root() + 'checkout';
    }).catch(function () {
      btn.removeAttribute('aria-busy');
      proceeding = true;
      btn.click();
    });
  }, true);
})();
